import React, { useEffect, useRef, useState } from "react"
import { sanitizeHtml } from "@/helpers/htmlUtils"

export const AdditionalInformation = ({ opening, sliceAdditionalInformation, isHtml = false }) => {
  const { note } = opening
  const [isExpanded, setIsExpanded] = useState(false)
  const [shouldShowExpandButton, setShouldShowExpandButton] = useState(true)
  const hiddenContentRef = useRef(null)
  const containerRef = useRef(null)

  const toggleExpand = () => setIsExpanded(prev => !prev)

  useEffect(() => {
    if (!sliceAdditionalInformation) {
      setShouldShowExpandButton(false)
      return
    }

    if (!hiddenContentRef?.current || !containerRef?.current) return

    const containerWidth = containerRef.current.offsetWidth
    const contentWidth = hiddenContentRef?.current.offsetWidth

    setShouldShowExpandButton(contentWidth > containerWidth)
  }, [sliceAdditionalInformation])

  if (!note) return null

  const Content = ({ className = "", ref = null }) => {
    const classes = `mb-0 font-size-big dashboard-card__information ${className}`.trim()

    if (isHtml) {
      return <p ref={ref} className={classes} dangerouslySetInnerHTML={{ __html: sanitizeHtml(note) }} />
    }

    return (
      <p ref={ref} className={classes}>
        {note}
      </p>
    )
  }

  const contentClassName = sliceAdditionalInformation && shouldShowExpandButton && !isExpanded ? "-sliced" : ""

  return (
    <div>
      <div ref={containerRef}>
        <Content className={contentClassName} />
        <Content className="-sliced -hidden" ref={hiddenContentRef} />
      </div>

      {sliceAdditionalInformation && shouldShowExpandButton && (
        <button
          className={`btn btn-link-primary btn-link arrow-down -after ${isExpanded ? "-open" : ""}`}
          onClick={toggleExpand}
          aria-expanded={isExpanded}
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  )
}
